import { useEffect, useState, useRef } from "react";
import './IndividualIngredient.css'
import { FaPlus } from "react-icons/fa6";
import { get, post, put } from '../../../Services/api';
import yyyy_mm_dd_date_format from "../../../Utility/yyyy_mm_dd_date_format";
import loading_display from "../../../Utility/loading_display";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, Radio, RadioGroup, InputLabel, MenuItem, Select, FormGroup, FormControlLabel, Checkbox, FormControl } from '@mui/material';

function AdminIndividualIngredient({ ingredient }) {

    const [similarIngredients, setSimilarIngredients] = useState([])
    const [mainIngredient, setMainIngredient] = useState(null)
    const [mergeIngredients, setMergeIngredients] = useState([])

    useEffect(() => {
        // Initiate all values
        constructor()
    }, [ingredient])

    async function constructor() {
        try {
            // Get similar ingredients
            await getSimilarIngredients()
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    async function getSimilarIngredients() {
        try {
            // set subscriber status
            const result = await get('/api/admin/ingredient/get-similar-ingredients?ingredient_id=' + ingredient.ingredient_id)

            setSimilarIngredients(result)
        } catch (error) {
            console.log(error)
        }
    }



    function selectedIngredientFunc(ingredient_tmp, checked, i) {
        if (checked) {
            if (mainIngredient) {
                setMergeIngredients(prev => [...prev, ingredient_tmp]);
                document.getElementById("admin_ingredients_ingredient_main_merge_" + i).style.accentColor = '';
            } else {
                setMainIngredient(ingredient_tmp);
                document.getElementById("admin_ingredients_ingredient_main_merge_" + i).style.accentColor = 'red';
            }
        } else {
            // Remove ingredient_tmp from mergeIngredients if it's in there
            setMergeIngredients(prev =>
                prev.filter(ing => ing.ingredient_id !== ingredient_tmp.ingredient_id)
            );

            // Also remove from mainIngredient if it's that one
            if (mainIngredient?.ingredient_id == ingredient_tmp.ingredient_id) {
                setMainIngredient(null); // or undefined depending on your default
            }
        }
    }

    async function mergeIngredientsFunc() {
        // Check if mainIngredient is set
        if (!mainIngredient) {
            alert("Please select a main ingredient to merge with.");
            return;
        }

        if (window.confirm("Are you sure you want to merge these ingredients? This action cannot be undone.")) {
            // Prepare the data to send
            const data = {
                main_ingredient_id: mainIngredient.ingredient_id,
                merge_ingredients: mergeIngredients.map(ing => ing.ingredient_id)
            };

            // Make the API call to merge ingredients
            await post('/api/admin/ingredient/merge-ingredients', data)
                .then(response => {
                    console.log('Merge successful:', response);
                    // Optionally, refresh the ingredient list or perform other actions
                    window.location.reload();
                })
                .catch(error => {
                    console.error('Error merging ingredients:', error);
                    alert("Error!");
                    window.location.reload();
                });

            // Reset the state after merging
            setMainIngredient(null)
            setMergeIngredients([])
        }
    }

    function clear() {
        // Reset the state after merging
        setMainIngredient(null)
        setMergeIngredients([])
    }


    return (
        <div className='admin_ingredients_indiv_ingredient'>

            <button onClick={() => mergeIngredientsFunc()}>Merge</button>
            <button onClick={() => clear()}>Clear</button>

            <div className='flex gap_20 width_100'>
                <div className='flex flex_column width_100'>

                    <div className={'admin_ingredients_list_indiv_ingredient admin_ingredients_list_indiv_ingredient_0'}>
                        <input
                            onChange={(e) => selectedIngredientFunc(ingredient, e.target.checked, 0)}
                            // style={{ accentColor: mainIngredient?.ingredient_id == ingredient?.ingredient_id ? 'red' : '' }}
                            id={"admin_ingredients_ingredient_main_merge_" + 0}
                            type='checkbox' className='admin_ingredients_list_indiv_ingredient_checkbox cursor_pointer' />

                        <div></div>
                        <p className="font_size_18">{ingredient.name}</p>
                        <p>|</p>
                        <p>{ingredient.unit_name}</p>
                    </div>

                    {similarIngredients?.map((similarIngredient, i) => (
                        <div key={i} className={'admin_ingredients_list_indiv_ingredient admin_ingredients_list_indiv_ingredient_' + (i + 1) % 2}>
                            <input
                                onChange={(e) => selectedIngredientFunc(similarIngredient, e.target.checked, (i + 1))}
                                // style={{ accentColor: mainIngredient?.ingredient_id == ingredient?.ingredient_id ? 'red' : '' }}
                                id={"admin_ingredients_ingredient_main_merge_" + (i + 1)}
                                type='checkbox' className='admin_ingredients_list_indiv_ingredient_checkbox cursor_pointer' />

                            <div></div>
                            <p className="font_size_18">{similarIngredient.name}</p>
                            <p>|</p>
                            <p>{similarIngredient.unit_name}</p>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}


export default AdminIndividualIngredient;